import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'SAR' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'SAR', label: 'Parabolic SAR', pane: 'main', params: [2, 2, 20], outputs: ['sar'], labels: ['Start', 'Step', 'Max'], dots: 'sar', tailSafe: false })
